export const SYSTEM_PERMISSION_IGNORE_LIST = [
  "add_logentry",
  "change_logentry",
  "delete_logentry",
  "view_logentry",
  "add_contenttype",
  "change_contenttype",
  "delete_contenttype",
  "view_contenttype",
  "add_session",
  "change_session",
  "delete_session",
  "view_session",
  "add_token",
  "change_token",
  "delete_token",
  "view_token",
  "add_tokenproxy",
  "change_tokenproxy",
  "delete_tokenproxy",
  "view_tokenproxy",
  "add_group",
  "change_group",
  "delete_group",
  "view_group",
  "add_reset",
  "change_reset",
  "delete_reset",
  "view_reset",
  "add_usertoken",
  "change_usertoken",
  "delete_usertoken",
  "view_usertoken",
];

export const BUSINESS_PERMISSION_MODELS = [
  "product",
  "user",
  "role_master",
  "permission",
  // "company_master", // Keep hidden until Company Management feature goes live.
];

export const MENU_PERMISSION_MATRIX = {
  assets: {
    requiredAllPermissions: [],
  },
  profile: {
    requiredAllPermissions: [],
  },
  changePassword: {
    requiredAllPermissions: [],
  },
  users: {
    requiredAnyPermissions: ["view_user", "add_user", "change_user", "delete_user"],
  },
  registerUser: {
    requiredAnyPermissions: ["add_user"],
  },
  roleManagement: {
    requiredAnyPermissions: [
      "view_role_master",
      "add_role_master",
      "change_role_master",
      "delete_role_master",
      "view_permission",
      "change_permission",
    ],
  },
  companyManagement: {
    requiredAnyPermissions: [
      "view_company_master",
      "add_company_master",
      "change_company_master",
      "delete_company_master",
    ],
  },
};

export const ROUTE_PERMISSION_MATRIX = {
  home: {
    requiredAnyPermissions: ["view_product"],
  },
  scan: {
    requiredAnyPermissions: ["view_product"],
  },
  users: MENU_PERMISSION_MATRIX.users,
  registerUser: MENU_PERMISSION_MATRIX.registerUser,
  roles: MENU_PERMISSION_MATRIX.roleManagement,
  company: MENU_PERMISSION_MATRIX.companyManagement,
};
